module.exports = __webpack_public_path__ + "static/media/logo_knolskape.4ba276db.png";